module.exports = __webpack_public_path__ + "static/img/es.acc72b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/mipmap-xxxhdpi/es.png
// module id = exhv
// module chunks = 18